import { TensileRequirementsPage } from "./TensileRequirementsPage";

const TensileRequirements = () => {
	return <TensileRequirementsPage />;
};
export default TensileRequirements;
